import {Box, Link, Typography, useMediaQuery} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useGlobalContext} from "../../../services/context.service";
import DownloadLink from "../../UI/Links/DownloadLink";
import {fnLocalizeFilter} from "../../../services/localize.service";
import {useEffect, useMemo, useState} from "react";

const BoxContainer = styled(Box)(() => ({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    fontWeight: 600,
    gap: 15
}));

interface ILinks {
    title: string;
    url: string;
}

export default function HelperLinks() {

    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();
    /* Отображаем QR только если разрешение менее 1024 */
    const matches = useMediaQuery('(max-width:1024px)');

    const [files, setFiles] = useState<{ [key: string]: any }>();
    const [links, setLinks] = useState<ILinks[]>([]);

    const getFilesAndLinks = async () => {
        const config = await fetch('config.json').then(function (response) {

            return response.json();
        });

        config && setFiles(config.files)
        config && setLinks(config.links || [])
    };

    useEffect(() => {
        getFilesAndLinks().then();
    }, []);

    const renderFiles = useMemo(() => {
        const arrLink = [];
        for (const key in files) {
            arrLink.push({link: key, title: files[key]})
        }

        return arrLink.map((item, idx) => (
            <Box key={item.link}><Typography sx={{display: "inline"}}>{idx + 1}. </Typography> <DownloadLink
                url={`./info/${item.link}`} title={`${item.title}`}/></Box>));
    }, [files]);

    const renderLinks = useMemo(() => {
        return links.map((item, idx) => (<Box key={item.url}>
            <Typography sx={{display: "inline"}}>{idx + 1}. </Typography>
            <DownloadLink url={item.url} title={item.title} target={"_blank"}/>
        </Box>))
    }, [links])

    return <>

        <BoxContainer>
            <Typography
                textAlign={'center'}>{fnLocalizeFilter(locale, '_lang.module.common.title.titleDocumentation')}:</Typography>
            {renderFiles}
            {links.length > 0 && <Typography
                textAlign={'center'}>{fnLocalizeFilter(locale, '_lang.module.common.title.titleLinks')}:</Typography>}
            {renderLinks}
        </BoxContainer>

        <BoxContainer></BoxContainer>
    </>
}
